export const formAddEleveSchema = {
  firstname: {
    presence: {
      allowEmpty: false,
      message: '^Ce champs est requis'
    }
  },
  lastname: {
    presence: { allowEmpty: false, message: '^Ce champs est requis' }
  }
};
